'use strict';

var React = require('react');

var SvgArrowsOutHorizontalFilledIcon = function SvgArrowsOutHorizontalFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 4a1 1 0 0 1 1 1v4h5.336l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414l1.293-1.293h-5.336v4a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1Z"
  }));
};
SvgArrowsOutHorizontalFilledIcon.displayName = "ArrowsOutHorizontalFilledIcon";

exports.SvgArrowsOutHorizontalFilledIcon = SvgArrowsOutHorizontalFilledIcon;
